import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { BlogpostService } from '../blogpost.service';
import { Category } from '../category';
import { School } from '../school';
 
@Component({
  selector: 'app-categories',
  templateUrl: './categories.component.html',
  styleUrls: ['./categories.component.css']
})
export class CategoriesComponent implements OnDestroy, OnInit {
  private destroy$ = new Subject<void>();

  categories: Category;
  school:School;
  error: {};
  dataFromService:any;
  constructor(private blogpostService: BlogpostService) { }

  ngOnInit() {
    this.blogpostService.getCategories().pipe(takeUntil(this.destroy$)).subscribe(
      (data: Category) => this.categories = data
    );
    this.blogpostService.getSchoolList().pipe(takeUntil(this.destroy$)).subscribe(
      (data: School) => this.school = data
    );
    // this.blogpostService.getSchoolList().pipe(takeUntil(this.destroy$)).subscribe(response => {
    //   this.dataFromService =response;
    //   console.log('asdasd dddo=====>'+JSON.stringify(this.dataFromService));
    // }); 




    // this.blogpostService.getSchoolList().pipe(takeUntil(this.destroy$)).subscribe(
    //   (data: school) => this.school = data
    // );
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

}
